import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'
import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import type { RelatedDocument, RelatedDocumentWithLink } from '../types/relatedDocument'
import { getInvoiceOrDraftRoute } from '../utils/getInvoiceOrDraftRoute'

const getRelatedDocumentRoute = (document: RelatedDocument): string => {
  if (document.documentType === InvoiceDocumentType.Quote) {
    return reactRoute.organization.quotes.getViewQuoteRoute(document.documentId)
  }

  return getInvoiceOrDraftRoute({
    billingStage: document.billingStage,
    documentId: document.documentId,
    documentType: document.documentType,
  })
}

export const useRelatedDocuments = (relatedDocuments: RelatedDocument[]): RelatedDocumentWithLink[] => {
  const { organization } = useUserOrganization()

  return useMemo(
    () =>
      relatedDocuments.map((document) => ({
        ...document,
        documentUrl: getOrganizationViewUrl(organization?.url, getRelatedDocumentRoute(document)),
      })),
    [organization?.url, relatedDocuments],
  )
}
